import { useSnackbar } from 'notistack';
import React from 'react';
import { useParams } from 'react-router-dom';
import { currentInquiryActions } from './store';

export default function LoadCurrentInquiry(props: { eventId?: number }) {
    const { eventId, id } = useParams<{ eventId: string; id: string }>();

    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        let resolvedEventId = props.eventId;

        if (resolvedEventId === undefined || resolvedEventId === null) {
            resolvedEventId = parseInt(eventId ?? id ?? '');
        }

        // Don't attempt to load if no eventId is available
        if (resolvedEventId === undefined || resolvedEventId === null || isNaN(resolvedEventId)) return;

        try {
            currentInquiryActions.load(resolvedEventId);
        } catch {
            enqueueSnackbar('Loading inquiry failed. Please try again.', { variant: 'error' });
        }
    }, [props.eventId, eventId, id, enqueueSnackbar]);

    return null;
}
